var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeskalaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 57,
    viewBox: "0 0 186 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2614 56.5226H3.99932C1.79058 56.5226 0 54.732 0 52.5233L0 3.99932C0 1.79058 1.79058 0 3.99932 0L28.2614 0C43.8696 0 56.5226 12.653 56.5226 28.2613V28.2614C56.5226 43.8696 43.8696 56.5226 28.2614 56.5226Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4669 11.6562V20.1055C31.4669 24.7719 27.6841 28.5548 23.0176 28.5548H14.5684C14.5684 19.222 22.1341 11.6562 31.4669 11.6562Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5684 27.9697H23.0176C27.6841 27.9697 31.4669 31.7525 31.4669 36.419V44.8682C22.1341 44.8682 14.5684 37.3025 14.5684 27.9697Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9493 28.6171C84.9493 25.4276 82.7956 23.4391 79.829 23.4391C76.8624 23.4391 74.7076 25.4276 74.7076 28.6171V33.2807C74.7076 36.4696 76.8624 38.4587 79.829 38.4587C82.7956 38.4587 84.9493 36.4696 84.9493 33.2807V28.6171ZM85.8851 39.8646C85.3682 39.8646 84.9493 39.4577 84.9493 38.9558V37.7044C83.8543 39.3501 81.8411 40.2074 79.829 40.2074C76.5437 40.2074 72.8359 38.4244 72.8359 33.2807V28.6171C72.8359 23.4735 76.5437 21.6904 79.829 21.6904C81.8411 21.6904 83.8543 22.5471 84.9493 24.1934V17.2253C84.9493 16.7233 85.3682 16.3164 85.8851 16.3164C86.4019 16.3164 86.8209 16.7233 86.8209 17.2253V38.9558C86.8209 39.4577 86.4019 39.8646 85.8851 39.8646Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9435 29.3647H104.203V28.536C104.203 25.3241 102.045 23.3215 99.0737 23.3215C96.1019 23.3215 93.9435 25.3241 93.9435 28.536V29.3647ZM114.743 40.2072H99.0737C95.7825 40.2072 92.0684 38.4117 92.0684 33.2318V28.536C92.0684 23.356 95.7825 21.5605 99.0737 21.5605C102.364 21.5605 106.078 23.356 106.078 28.536V29.9091C106.078 30.581 105.52 31.1256 104.832 31.1256H94.5664C94.2226 31.1256 93.9435 31.398 93.9435 31.7339V33.2318C93.9435 36.443 96.1019 38.4462 99.0737 38.4462H114.794L114.743 40.2072Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.766 38.4443C117.193 38.4443 119.339 37.4769 119.339 35.4399C119.339 33.7827 118.424 32.5392 116.243 32.0903L112.162 31.193C109.629 30.64 107.801 29.2242 107.801 26.4271C107.801 23.2158 110.897 21.5586 114.132 21.5586C117.135 21.5586 119.777 23.0055 120.548 25.9725C120.702 26.5678 120.26 27.1527 119.634 27.1527C119.193 27.1527 118.826 26.8492 118.714 26.4308C118.183 24.4558 116.367 23.3195 114.097 23.3195C111.88 23.3195 109.665 24.2168 109.665 26.4271C109.665 28.0503 110.58 28.9482 112.795 29.4311L116.278 30.1911C119.69 30.9161 121.203 32.4701 121.203 35.4745C121.203 38.548 118.565 40.2052 114.73 40.2052",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.029 31.7355L134.699 22.7871C134.869 22.6111 135.109 22.5108 135.361 22.5108C136.146 22.5108 136.555 23.3997 136.024 23.9489L130.678 29.4722L137.365 38.8673C137.77 39.4367 137.341 40.2055 136.619 40.2055H136.524C136.225 40.2055 135.946 40.0647 135.779 39.8298L129.344 30.8097L126.029 34.2388V39.3481C126.029 39.8219 125.625 40.2055 125.128 40.2055H125.02C124.522 40.2055 124.119 39.8219 124.119 39.3481V17.1718C124.119 16.6983 124.522 16.3145 125.02 16.3145H125.128C125.625 16.3145 126.029 16.6983 126.029 17.1718V31.7355Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.576 39.2976V17.224C162.576 16.722 162.968 16.3154 163.45 16.3154C163.933 16.3154 164.324 16.722 164.324 17.224V39.2976C164.324 39.7995 163.933 40.2064 163.45 40.2064C162.968 40.2064 162.576 39.7995 162.576 39.2976Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.755 22.7236C149.444 22.7236 149.134 22.8791 148.967 23.1903L140.535 38.9277C140.224 39.508 140.654 40.2049 141.323 40.2049H158.187C158.856 40.2049 159.286 39.508 158.975 38.9277L150.543 23.1903C150.376 22.8791 150.066 22.7236 149.755 22.7236ZM149.755 25.5699L156.638 38.415H142.872L149.755 25.5699Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7637_4245",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 22,
    width: 19,
    height: 19
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.375 22.9971H186V40.3255H167.375V22.9971Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7637_4245)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.688 22.9971C176.378 22.9971 176.067 23.1511 175.901 23.4596L167.478 39.0595C167.167 39.6347 167.597 40.3255 168.265 40.3255H185.11C185.778 40.3255 186.208 39.6347 185.897 39.0595L177.474 23.4596C177.308 23.1511 176.998 22.9971 176.688 22.9971ZM176.688 25.8184L183.562 38.5512H169.813L176.688 25.8184Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskalaLogo);
export default __webpack_public_path__ + "static/media/deskalaLogo.cc15e8981e2b93c168599edb5196a632.svg";
export { ForwardRef as ReactComponent };